<template>
  <v-card width="100%" height="100%" outlined>
    <v-toolbar color="secondary" dark class="title" flat>
      <v-icon left>{{settingInfo.new ? 'fas fa-plus-circle' : 'fas fa-edit'}}</v-icon>
      {{settingInfo.new ? 'Add Setting' : 'Edit Setting'}}
    </v-toolbar>
    <v-card-text>
      <v-row>
          <v-col cols="12">
              <v-text-field label="Item Title:" color="secondary" outlined v-model="settingInfo.item"></v-text-field>
          </v-col>
          <v-col cols="12">
              <v-select label="Category:" :items="categories" item-color="accent" clearable color="secondary" outlined v-model="settingInfo.category"></v-select>
          </v-col>
          <v-col cols="12">
              <v-text-field label="Link:" color="secondary" outlined v-model="settingInfo.value"></v-text-field>
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" class="text-center">
            <v-btn @click="cancel()" outlined color="red">
            <v-icon left small>fas fa-times</v-icon>
            Cancel
            </v-btn>
        </v-col>
        <v-col cols="6" class="text-center">
            <v-btn outlined @click="addSetting()" :disabled="!readyToSubmit()">
              <v-icon left small>fas fa-check</v-icon>
              {{settingInfo.new ? 'Add Setting' : 'Edit Setting'}}
            </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
      selectedSetting: Object
  },
  data(){
    return {
        categories  : ["Admin", "Financial", "Kids at The Mount", "Missions", "Students at The Mount"],
        settingInfo : this.selectedSetting
    }
  },
  methods: {
      addSetting(){
          if (this.settingInfo.new == true) {
            this.$store.dispatch('addSetting', this.settingInfo)
          }
          else {
            this.$store.dispatch('saveSettings', [this.settingInfo])
          }
          // this.$emit('close')
      },
      cancel(){
        this.settingInfo = {}
        this.$emit('close')
      },
      readyToSubmit(){
        if (this.settingInfo.item && this.settingInfo.value && this.settingInfo.category) {
          return true
        }
        else {
          return false
        }
      }
  },
  computed: {
    
  }
}
</script>
